import { createI18n } from 'vue-i18n';
import i18nMinside from './nb-NO/translation.json';

const i18n = createI18n({
  legacy: true,
  locale: 'no',
  fallbackLocale: 'no',
  globalInjection: true,
  messages: {
    no: i18nMinside,
  },
});

export default i18n;
